import React from 'react';
import LoginPresenter from '../presenters/LoginPresenter';
import { useLogin } from '../hooks/useLogin';

const LoginContainer = ({ onLogin, onGoToSignUp }) => {
  const {
    formData,
    isLoading,
    error,
    needsVerification,
    verificationCode,
    rememberMe,
    forgotStep,
    forgotEmail,
    forgotCode,
    forgotNewPassword,
    handleSubmit,
    handleVerification,
    handleResendCode,
    handleInputChange,
    handleForgotPassword,
    handleForgotSubmitEmail,
    handleForgotConfirm,
    handleCancelForgot,
    setForgotEmail,
    setForgotCode,
    setForgotNewPassword,
    setVerificationCode,
    setRememberMe,
    setNeedsVerification,
  } = useLogin();

  return (
    <LoginPresenter
      // Data
      formData={formData}
      isLoading={isLoading}
      error={error}
      needsVerification={needsVerification}
      verificationCode={verificationCode}
      rememberMe={rememberMe}
      forgotStep={forgotStep}
      forgotEmail={forgotEmail}
      forgotCode={forgotCode}
      forgotNewPassword={forgotNewPassword}

      // Actions
      onSubmit={(e) => { e.preventDefault(); handleSubmit(onLogin); }}
      onVerification={(e) => { e.preventDefault(); handleVerification(onLogin); }}
      onResendCode={handleResendCode}
      onInputChange={handleInputChange}
      onForgotPassword={handleForgotPassword}
      onForgotSubmitEmail={handleForgotSubmitEmail}
      onForgotConfirm={() => handleForgotConfirm(onLogin)}
      onCancelForgot={handleCancelForgot}
      onForgotEmailChange={setForgotEmail}
      onForgotCodeChange={setForgotCode}
      onForgotNewPasswordChange={setForgotNewPassword}
      onVerificationCodeChange={setVerificationCode}
      onRememberMeChange={setRememberMe}
      onBackToLogin={() => setNeedsVerification(false)}
      onGoToSignUp={onGoToSignUp}
    />
  );
};

export default LoginContainer;
